<template>
  <div>
    <table class="table table-striped mt-2">
      <thead class="" style="background-color: var(--coredarkcolor); color: var(--corelightcolor);">
        <tr class="">
          <!-- <th scope="col">Name</th> -->
          <th scope="col">Job</th>
          <th scope="col">Application Date</th>
          <!-- <th scope="col">Status</th> -->
          <!-- <th scope="col">Profile</th> -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="application in applications" :key="application.id" style="cursor: pointer;">
          <!-- <td>
            {{ application.applicant_name }}
          </td> -->
          <td>
            {{ application.job_title }}
          </td>
          <td>
            <p>{{ new Date(application.date).toDateString() }}</p>
          </td>
          <!-- <td>
            {{ application.status }}
          </td> -->
          <!-- <td>
            <router-link
              :to="{ name: 'Candidate Viewable Dashboard', params: { id: application.applicant } }"
              class=""
              target="_blank"
            >View Profile</router-link>
          </td> -->
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['user'],
  data() {
    return {
      applications: [],
    }
  },
  created() {
    this.getApplications()
  },
  methods: {
    getApplications(job) {
      axios.get(`/api/jobapplications/?applicant=${this.user.id}`)
        .then(res => {
          console.log(res)
          this.applications = res.data
          this.applications = this.applications.sort((a, b) => (a.date < b.date) ? 1 : -1)

          // this.$modal.show('job-modal')
        })
        .catch(error => console.log(error))
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/agents/tables/JobApplications.vue